<template>
<div class='bottomlogo'>
  <img src='@/assets/images/nomore.png' />
</div>
</template>

<script>
export default {
  name: '',
  data() {
        return {
          title:""
      }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.bottomlogo img{
  width: 100%;
}
</style>